/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_unlock_tier_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock Tier A Predictions`)
};

const es_f1_budget_unlock_tier_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear Predicciones Tier A`)
};

const de_f1_budget_unlock_tier_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tier A Prognosen freischalten`)
};

const nl_f1_budget_unlock_tier_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tier A-voorspellingen ontgrendelen`)
};

const fr_f1_budget_unlock_tier_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déverrouiller les prédictions Tier A`)
};

const it_f1_budget_unlock_tier_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca previsioni Tier A`)
};

const pt_br2_f1_budget_unlock_tier_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear previsões Tier A`)
};

const pt_f1_budget_unlock_tier_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear previsões Tier A`)
};

const ja_f1_budget_unlock_tier_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ティアA予測をアンロック`)
};

const zh_f1_budget_unlock_tier_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁A级预测`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_unlock_tier_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_unlock_tier_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_unlock_tier_a", locale)
	if (locale === "en") return en_f1_budget_unlock_tier_a(inputs)
	if (locale === "es") return es_f1_budget_unlock_tier_a(inputs)
	if (locale === "de") return de_f1_budget_unlock_tier_a(inputs)
	if (locale === "nl") return nl_f1_budget_unlock_tier_a(inputs)
	if (locale === "fr") return fr_f1_budget_unlock_tier_a(inputs)
	if (locale === "it") return it_f1_budget_unlock_tier_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_unlock_tier_a(inputs)
	if (locale === "pt") return pt_f1_budget_unlock_tier_a(inputs)
	if (locale === "ja") return ja_f1_budget_unlock_tier_a(inputs)
	return zh_f1_budget_unlock_tier_a(inputs)
};